import api from '../api';
import request from "../utils/requestToOnlineServiceServer";

export function ADD_TASK_ASYNC(formData: {
    company: string,
    KDD: number,
    kdd_short: number | null,
    file_id: string,
    type: string,
    ecg_meta_info: {
        device: string,
        start_time: string,
        check_time: string,
        filename: string,
        data_type: string,
        sample_rate: string,
        lead: number[],
    },
    user_info: {
        name: string,
        age: string,
        gender: string,
    }
}) {
    return new Promise((resolve, reject) => {
        request.post(api.onlineServiceApi.TASK_ASYNC, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function GET_TASK_STATUS({ task_id }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.onlineServiceApi.TASK_STATUS, {
            params: {
                task_id
            }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function GET_TASK_RESULT_FILE({ task_id, type }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.onlineServiceApi.TASK_RESULT_FILE, {
            params: {
                task_id,
                type
            }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}

export function GET_STATIC_RESULT({ task_id }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.onlineServiceApi.TASK_STATIC_RESULT, {
            params: {
                task_id,
            }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}

export function ADD_TASK_SYNC(formData: {
    // {"data":[],"ecg_meta_info":{"id":"xx","sample_rate":"250","ratio":"0.0024","lead":[1,2,3,4]},"user_info":{"id":"xxx","name":"jxy","age":"30","gender":"woman"},"AI_task":{"r":{"detection":1,"label":1},"af":"segment","denoise":1}}
    data: any[],
    ecg_meta_info: {
        id: string,
        sample_rate: string,
        ratio: string,
        lead: number[],
    },
    user_info: {
        id: string,
        name: string,
        age: string,
        gender: string,
    },
    AI_task: {
        r: {
            detection: number,
            label: number,
        }, 
        af: string,
        denoise: number,
    }}) {
    return new Promise((resolve, reject) => {
        request.post(api.onlineServiceApi.TASK_SYNC, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}

export function ADD_TASK_SYNC_WITH_FILE(formData: {
    // {"datFile":"xxx","ecg_meta_info":{"id":"xx","filename":"jxy","data_type":"dat","sample_rate":"250","ratio":"0.0024","lead":[1,2,3,4]},"user_info":{"id":"xxx","name":"jxy","age":"30","gender":"woman"},"AI_task":{"r":{"detection":0,"label":0},"af":"","denoise":0}}
    datFile: string,
    ecg_meta_info: {
        id: string,
        filename: string,
        data_type: string,
        sample_rate: string,
        ratio: string,
        lead: number[],
    },
    user_info: {
        id: string,
        name: string,
        age: string,
        gender: string,
    },
    AI_task: {
        r: {
            detection: number,
            label: number,
        }, 
        af: string,
        denoise: number, 
    }
}) {
    return new Promise((resolve, reject) => {
        request.post(api.onlineServiceApi.TASK_SYNC_WITH_FILE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}

export function UPLOAD_FILE(formData: {
    file: File
}) {
    const data = new FormData();
    data.append('file', formData.file); // 'file' 是后端需要接收的字段名
    console.log("接收到的 file 是：", formData.file);
    console.log("file instanceof File:", formData.file instanceof File);

    return new Promise((resolve, reject) => {
        request.post(api.onlineServiceApi.UPLOAD_FILE, data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}


export function GET_ARRAY_DATA({ task_id }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.onlineServiceApi.GET_ARRAY_DATA, {
            params: {
                task_id
            }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    }) 
}